import {
  DASHBOARD_GRID_COLUMNS,
  DASHBOARD_GUTTER_PX,
  DASHBOARD_ROW_HEIGHT_PX,
} from "./dashboardWidgetSizing"
import {
  getResponsiveGridContainerWidth,
  getScaledGridDimensions,
} from "./gridResponsiveDimensions"

/**
 * Pixel measurements of the dashboard grid, for the pieces that need to reason
 * about a widget's rendered size without measuring the DOM.
 */
export const GRID_CONFIG = {
  ROW_HEIGHT: DASHBOARD_ROW_HEIGHT_PX,
  MARGIN: [DASHBOARD_GUTTER_PX, DASHBOARD_GUTTER_PX] as [number, number],
  CONTAINER_PADDING: [0, DASHBOARD_GUTTER_PX] as [number, number],
}

const SCALING_CONFIG = {
  ENABLE_PROPORTIONAL_SCALING: true,
  BASE_VIEWPORT_WIDTH: 1200,
  MIN_CONTAINER_WIDTH: 320,
  MAX_CONTAINER_WIDTH: 2400,
}

export const GRID_COLUMNS = DASHBOARD_GRID_COLUMNS

export function getScaledDimensions(containerWidth?: number): {
  rowHeight: number
  margin: [number, number]
  containerPadding: [number, number]
} {
  return getScaledGridDimensions(GRID_CONFIG, SCALING_CONFIG, containerWidth)
}

export function getResponsiveContainerWidth(): number {
  return getResponsiveGridContainerWidth(SCALING_CONFIG)
}
